import { atom } from 'recoil'

export const ACTION_SEND_MESSAGE = 0
export const ACTION_SEND_SMS = 1
export const ACTION_MOVE_COPY = -1

export const taskState = atom({
  key: 'taskState',
  default: {
    IdList: 0,
    Name: '',
    Description: '',
    Enabled: false,
    CustomerTimeZone: '',
    StartDate: '',
    EndDate: '', // passare solo se valorizzato
    NextCalcRunDate: '', // passare solo se valorizzato
    NextRealRunDate: '', // passare solo se valorizzato
    Tags: [],
    Frequency: {
      KindDateFrequency: 'd',
      DateFrequency: 1,
      StartHour: 0,
      StartMinute: 0,
      DailyFrequency: 0,
      AsSoonAsPossible: false,
      UrlFrequency: 0,
      Url: '',
      KindOfUrl: '',
      NotInWeekends: false,
      BlackoutStartHour: '', // passare solo se valorizzato
      BlackoutEndHour: '', // passare solo se valorizzato
      FrequencyBlackoutDate: [],
      FrequencyMonthlyChoosenDay: [],
      FrequencyWeeklyChoosenDay: [],
      FrequencyYearlyChoosenDay: [],
      ChoosenDays: []
    },
    Detail: {
      Action: 0,
      Sender: '',
      SenderName: '',
      ReplyTo: '',
      CustomSender: false,
      IdMessage: 0,
      FromGroup: 0,
      ToGroup: 0,
      ApplyConditionsEvent: false,
      ApplyConditionsField: false,
      ApplyConditionsFilter: false,
      IdSenderNameField: 0,
      IdSenderEmailField: 0,
      ApplyConditionsRule: '',
      GroupsCondition: false,
      FiltersCondition: false,
      FilterConditionsRules: '',
      FrequencySafeGuard: 0,
      IdFieldUTCCode: 0,
      TaskApplyConditionsFilter: [],
      TaskApplyConditionsEvent: {
        DaysFromLastEvent: 0,
        IdEventFilter: 0
      },
      TaskApplyConditionsField: {
        // passare solo se valorizzato
        IdFieldFilter: 0,
        IdField: 0,
        FieldValue: '',
        FieldType: 0
      },
      Filter: [],
      Group: []
    },
    Id: 0,
    nameIsDiry: false,
    isDirty: false,
    enableIdFieldUTCCode: false,
    isDirtyDetailAction: false,
    saveTask: false,
    changeStep: false
  }
})

export const tagsListState = atom({
  key: 'tasktagsListState',
  default: {
    tagsList: []
  }
})

export const dynamicFieldState = atom({
  key: 'taskdynamicFieldState',
  default: {
    tagsList: []
  }
})

export const messagesState = atom({
  key: 'taskMessagesState',
  default: {
    items: []
  }
})

export const smsState = atom({
  key: 'taskSmsState',
  default: {
    items: []
  }
})

export const filtersState = atom({
  key: 'taskfiltersState',
  default: {
    filters: []
  }
})

export const anagFiltersState = atom({
  key: 'anagFiltersState',
  default: {
    items: []
  }
})

export const otherFiltersState = atom({
  key: 'otherFiltersState',
  default: {
    items: []
  }
})

export const rssFeedsState = atom({
  key: 'rssFeedsState',
  default: {
    items: []
  }
})

export const senderConfigState = atom({
  key: 'taskListDataState',
  default: {
    SenderEmail: '',
    SenderName: '',
    SenderNameSMS: '',
    SenderReplyTo: '',
    IsPecPlus: false,
    FetchedSender: false,
    IsDiry: false,
    CustomSender: false,
    senderNameIsDiry: false,
    IdSenderNameField: 0,
    IdSenderEmailField: 0,
    customEmailValueIsDirty: false,
    customNameValueIsDirty: false,
    replyToEmailIsDirty: false,
    invalidReplyTo: false,
    senderNameSMSIsDirty: false,
    IdMessage: false,
    idMessageIsDirty: false,
    sernderEmailValid: true,
    sernderSmsValid: true,
    listData: undefined,
    previousAction: undefined
  }
})

export const taskConditionsState = atom({
  key: 'taskConditionsState',
  default: {
    isDirty: false,
    FrequencySafeGuard: 24,
    FrequencySafeGuardHour: 24,
    ApplyConditionsRule: 'AND',
    IncludeGroups: [],
    ExcludeGroups: [],
    Filters: [],
    FilterConditionsRules: 'AND',
    ApplyConditionsEvent: false,
    TaskApplyConditionsEvent: {
      DaysFromLastEvent: 0,
      IdEventFilter: 1
    },
    ApplyConditionsField: false,
    TaskApplyConditionsField: {
      IdFieldFilter: 0,
      IdField: 0,
      FieldValue: '',
      FieldType: 0
    },
    AnagFilterTrue: false,
    AnagFilterTrueId: 0,
    AnagFilterFalse: false,
    AnagFilterFalseId: 0,
    OtherFilterTrue: false,
    OtherFilterTrueId: 0,
    OtherFilterFalse: false,
    OtherFilterFalseId: 0
  }
})

export const exceptionsState = atom({
  key: 'exceptionsState',
  default: {
    isDirty: false,
    activiteFor: 'FromDate',
    StartDate: new Date(),
    EndDate: new Date(),
    FrequencyBlackoutDate: [],
    NotInWeekends: false,
    UrlFrequency: 1,
    urlFrequencyEnabled: false,
    Url: '',
    KindOfUrl: '',
    frequencyBlackoutHourEnabled: false,
    startBOTime: {
      hours: 0,
      minutes: 0
    },
    endBOTime: {
      hours: 0,
      minutes: 0
    }
  }
})

export const recapState = atom({
  key: 'recapState',
  default: {
    actionExpanded: false,
    conditionExpanded: false,
    frequencyExpandend: false,
    infoExpanden: true,
    subject: '',
    fromGroup: '',
    ToGroup: '',
    conditions: {
      includeGroups: [],
      excludeGroups: [],
      filters: [],
      anagFilterTrue: '',
      anagFilterFalse: '',
      otherFilterTrue: '',
      otherFilterFalse: ''
    }
  }
})

export const taskPanelFrequencyState = atom({
  key: 'taskPanelFrequencyState',
  default: {
    radioAt: true,
    isDirty: false
  }
})
